import { useCallback } from "react";
import { useSessionContext } from "@newHooks/context/session/session.context";

export const useUpdateExpiryAt = () => {
  const { session, onSetSession } = useSessionContext();

  const updateExpiryAt = useCallback(
    (expiryAt: Date) => {
      if (!session) {
        throw new Error("Update target session is not exist");
      }

      onSetSession({ ...session, expiryAt });
    },
    [session, onSetSession]
  );

  return updateExpiryAt;
};
